import React from "react";
import CurrentAvailableReport from "../modules/CurrentAvailableReport";

export default function CurrentAvailableReportPage() {
    return <CurrentAvailableReport/>
}